function toNative(p) {
    if (p && typeof p.then === 'function' && !(p instanceof Promise)) {
        return new Promise((resolve, reject) => p.then(resolve, reject));
    }
    return Promise.resolve(p);
}

export class PromiseCache {
    constructor() {
        this.store = new Map();
        this.inflight = new Map();
    }

    /**
     * getTransformed reproduit exactement le pattern:
     *   req = fetcher()
     *   chained = req.then(transform...)
     *   inflight.set(key, chained)
     *   cache.set(key, transformed)
     */
    getTransformed(key, { ttlMs = 20000, noCache = false } = {}, fetcher, transform = (x) => x) {
        if (!noCache) {
            const hit = this.store.get(key);
            if (hit && (ttlMs === 0 || Date.now() - hit.ts < ttlMs)) {
                return Promise.resolve(hit.data);
            }
            const p0 = this.inflight.get(key);
            if (p0) return p0;
        }

        const req = fetcher();
        const chained = toNative(req).then(
            (response) => {
                const data = transform(response);
                if (!noCache) {
                    this.store.set(key, { data, ts: Date.now() });
                    this.inflight.delete(key);
                }
                return data;
            },
            (err) => {
                if (!noCache) this.inflight.delete(key);
                throw err;
            }
        );

        if (!noCache) this.inflight.set(key, chained);
        return chained;
    }

    clear(key) {
        if (key) {
            this.store.delete(key);
            this.inflight.delete(key);
        } else {
            this.store.clear();
            this.inflight.clear();
        }
    }
}

const sharedCache = new PromiseCache();
export default sharedCache;
